import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  notification,
  DatePicker,
  Select,
  Card,
} from "antd";
import { API } from "../../config/api";
import { useNavigate, useParams } from "react-router-dom";
import { POST, PUT, GET } from "../../utils/apicalls";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import moment from "moment";
import PageHeader from "../../admin/pageHeader/pageheader";

function TelecallerWorkUpdate() {
  const { id } = useParams<{ id: string }>(); // Ensure 'id' is correctly typed
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state?.user);

  const onFinish = async (values: any) => {
    try {
      const payload = {
        type: values.type,
        enquery_name: values.enquery_name,
        date: values.date,
        feedback: values.feedback,
        enquery_phone: values.enquery_phone,
        wrokUpdate: values.wrokUpdate,
        altPhone: values.altPhone,
        employeeId: user.id,
      };

      const api = `${API.UPDATE_TELECALLER}${id}`;
      const response = await PUT(api, payload);

      if (response) {
        notification.success({
          message: "Telecaller details updated successfully",
        });
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error("Error updating visitors data:", error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    }
  };

  const fetchVisitorDetails = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(`${API.GET_ONE_TELECALLER}${id}`, {}); // Replace with your endpoint
      if (response) {
        form.setFieldsValue({
          ...response.data,
          date: response.data.date ? moment(response.data.date) : null, // Ensure the date is correctly formatted for Ant Design's DatePicker
        });
      }
    } catch (error) {
      console.error("Error fetching visitor details:", error);
      notification.error({
        message: "Error loading visitor details. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchVisitorDetails();
    }
  }, [id]);

  return (
    <div>
      <PageHeader />
      <h1 style={{ textAlign: "center" }}>Update Telecaller Work Details</h1>
      <Card>
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="enquery_name"
                label="Enquiry Name"
                rules={[{ required: true, message: "Enter Enquiry Name" }]}
              >
                <Input placeholder="Enquiry Name" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="type"
                label="Type"
                rules={[{ required: true, message: "Enter Type" }]}
              >
                <Input placeholder="Type" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="date"
                label="Date"
                rules={[{ required: true, message: "Enter Date" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="feedback"
                label="feedback"
                rules={[{ required: true, message: "Enter Feedback" }]}
              >
                <Input placeholder="Feedback" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="enquery_phone"
                label="Enquiry Phone"
                rules={[{ required: true, message: "Enter Enquiry Phone" }]}
              >
                <Input placeholder="Enquiry Phone" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="wrokUpdate"
                label="Work Update"
                rules={[{ required: true, message: "Enter Work Update" }]}
              >
                <Select placeholder="Select status">
                  <Select.Option value="Pending">Pending</Select.Option>
                  <Select.Option value="inProgress">In Progress</Select.Option>
                  <Select.Option value="Completed">Completed</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item>
                <button type="submit" disabled={isLoading}>
                  {isLoading ? "Loading..." : "Update"}
                </button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default TelecallerWorkUpdate;
